module.exports = __webpack_public_path__ + "static/media/czfm.86f9c8f0.png";